import { Tabs } from 'antd'
import { useSelector } from 'react-redux'
import { faAddressBook, faPeopleArrows } from '@fortawesome/pro-solid-svg-icons'

import IconLabel, { FontSizes } from '../../../Components/icons/IconLabel'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import InternalContactPersonsView from './InternalContactPersonsView'
import ExternalContactPersonsView from './ExternalContactPersonsView'

const { TabPane } = Tabs

const ContactPersons = () => {
  const t = useSelector(selectTranslate)

  return (
    <Tabs animated={false}>
      <TabPane
        key='1'
        tab={<IconLabel fontSize={FontSizes.SMALL} icon={faPeopleArrows} text={t('contact_persons_view.first_tab')} />}
      >
        <InternalContactPersonsView />
      </TabPane>
      <TabPane
        key='2'
        tab={<IconLabel fontSize={FontSizes.SMALL} icon={faAddressBook} text={t('contact_persons_view.second_tab')} />}
      >
        <ExternalContactPersonsView />
      </TabPane>
    </Tabs>
  )
}

export default ContactPersons
